import { useMemo } from "react";
import { TableEditorConfig } from "../table-editor";
import { Value } from "../table-editor/dto";
import { getFormulaValue } from "../table-editor/utils";

const useFormulaData = (config: TableEditorConfig, dataSource: Value[]) => {
  return useMemo(() => {
    const formulas = config?.formulas?.filter((f) => f.value.length > 0) ?? [];
    if (formulas.length === 0) {
      return dataSource;
    }
    const newDataSource = [...dataSource];
    for (const formula of formulas) {
      if (formula.custom || formula.value.length === 0) {
        continue;
      }
      const idx = dataSource.findIndex((d) => d.code === formula.code);
      if (idx === -1) {
        continue;
      }
      const value = getFormulaValue(formula.value, dataSource);
      newDataSource.splice(idx, 1, {
        ...dataSource[idx],
        [dataSource[idx].isList ? "valueList" : "value"]: value,
      });
    }
    return newDataSource;
  }, [JSON.stringify(config?.formulas), JSON.stringify(dataSource)]);
};

export default useFormulaData;
